export default [
    {
        name     : 'APP_LOGIN_SUCCESS',
        callback : function (e) {
            this.$router.push({ path : '/relatorios' });
            this.snackbar = {
                show  : true,
                color : 'green',
                text  : 'Login efetuado com sucesso.'
            };
        }
    },
    {
        name     : 'APP_LOGIN_FAILED',
        callback : function (e) {
            this.snackbar = {
                show  : true,
                color : 'red',
                text  : 'Usuário e/ou senha invalido(s).'
            };
        }
    },
    {
        name     : 'APP_LOGOUT',
        callback : function (e) {
            this.snackbar = {
                show  : true,
                color : 'green',
                text  : 'Logout efetuado com sucesso.'
            };
            this.$router.push({ path : '/login' });
        }
    },
    {
        name     : 'APP_PAGE_LOADED',
        callback : function (e) {
        }
    },
    {
        name     : 'APP_AUTH_FAILED',
        callback : function (e) {
            this.$router.push('/login');
            this.$message.error('Token expirou');
        }
    },
    {
        name     : 'APP_BAD_REQUEST',
        // @error api response data
        callback : function (msg) {
            this.$message.error(msg);
        }
    },
    {
        name     : 'APP_ACCESS_DENIED',
        // @error api response data
        callback : function (msg) {
            this.$message.error(msg);
            this.$router.push('/forbidden');
        }
    },
    {
        name     : 'APP_RESOURCE_DELETED',
        // @error api response data
        callback : function (msg) {
            this.$message.success(msg);
        }
    },
    {
        name     : 'APP_RESOURCE_UPDATED',
        // @error api response data
        callback : function (msg) {
            this.$message.success(msg);
        }
    },

];
